export class Feature
{
	featureId: number;
	featureType: string;
	highlight: number;
	propertyFeatureId: number;
	describesType: string;
    action: string;
}
